import React, { useState } from 'react'
import GenricMultiSelect from '../../components/Input/GenericMultiSelect'
import { IconButton, Stack } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons';
import { eventsAdderTypes } from '../../features/manageEvents/ManageEventsType';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';

function EventsAdder(props: eventsAdderTypes) {
    const { translate } = usePortalTranslation();
    const CUR_COMPONENT = "Manage Events"
    const { options, handleAddClick } = props
    const [selectedOptions, setSelectedOptions] = useState<Array<string>>([]);

    const handleMultiSelectState = (selected: string[]) => {
        setSelectedOptions(selected)
    }
    return (
        <Stack sx={{ width: '100%',alignItems:'center' }} direction={"row"} spacing={2}>
                <div className="manage-events-multi-select-wrapper">
                    <GenricMultiSelect
                        options={options}
                        label={translate(TranslationEnum.manage_events,"Add Events")}
                        selectedOptions={selectedOptions}
                        isRequired={false}
                        handleMultiSelectState={handleMultiSelectState} />
                </div>
                <IconButton aria-label="add" size="small" disabled={selectedOptions.length === 0}>
                    <FontAwesomeIcon
                        onClick={() => {
                            handleAddClick(selectedOptions)
                            setSelectedOptions([])
                        }}
                        className={`add-event-plus-icon ${selectedOptions.length === 0 ? 'disabled' : ''}`}
                        icon={faCirclePlus}
                    />
                </IconButton>
        </Stack>
    )
}

export default EventsAdder